import { render, staticRenderFns } from "./ApplyProductDiscountsView.vue?vue&type=template&id=74b260bc&scoped=true&"
import script from "./ApplyProductDiscountsView.vue?vue&type=script&lang=ts&"
export * from "./ApplyProductDiscountsView.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyProductDiscountsView.vue?vue&type=style&index=0&id=74b260bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b260bc",
  null
  
)

export default component.exports